import React from 'react'
import WelcomePage from '../WelcomePage/WelcomePage'

export default function Home() {
  return (
    <>
    <WelcomePage/>
    </>
  )
}
